import { dataDiamond } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDiamond = /*#__PURE__*/createIcon(dataDiamond)
export default IconDiamond
